import { Feature, t, TLabel } from "util/stdtypes";
import { SpacesConfig, SpaceTemplate } from "feature/editorial-dash/spaces";
import { View, StyleSheet } from "react-native";
import { TextField, UtilityText } from "component/text";
import { FormField } from "component/form";
import { colorTextSecondary } from "component/color";
import { getFontSize } from "platform-specific/font";

function ConfigWidget({spaceProps, setSpaceProps}) {
    return <View>
        <FormField label={t('Perspectives (required)')} descriptionLabel={t('Separate perspectives with a line break.')}>
            <TextField multiline={true} big placeholder={t('Write 3-5 perspectives...')}
                value={spaceProps.perspectives} onChangeText={(text) => setSpaceProps({...spaceProps, perspectives: text})}
            />
        </FormField>
    </View>
}

export const RepresentingPerspectivesTemplate : SpaceTemplate = {
    key: 'representing-perspectives',
    label: t('Representing Perspectives'),
    description: t('Ask users from a specific set of perspectives to respond to your question.'),
    imageUrl: 'images/representing-perspectives.svg',
    structureKey: 'question',
    featuresEnabled: ['representing_perspectives'],
    configWidget: ConfigWidget,
}

export const RepresentingPerspectivesTemplateFeature : Feature<SpacesConfig, {}> = {
    key: 'representing-perspectives-template',
    name: 'Representing Perspectives Template',
    providesConfig: {
        templates: [RepresentingPerspectivesTemplate]
    }
}

